import React from "react";

const MandatorySymbol = () => <span style={{ color: "red" }}>*</span>;

export default MandatorySymbol;
